<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CG7PnR/tc-custom/9781625845832.jpg?1705208132808" alt="This image is the cover for the book Wicked Women of New Mexico"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wicked Women of New Mexico
      </h1>
      <p class="bookDescription body article font2">
        <p>New Mexico Territory attracted outlaws and desperados as its remote locations guaranteed non-detection while providing opportunists the perfect setting in which to seize wealth. Many wicked women on the run from their pasts headed there seeking new starts before and after 1912 statehood. Colorful characters such as Bronco Sue, Sadie Orchard and Lizzie McGrath were noted mavens of mayhem, while many other women were notorious gamblers, bawdy madams or confidence tricksters. Some paid the ultimate price for crimes of passion, while others avoided punishment by slyly using their beguiling allure to influence authorities. Follow the raucous tales of these wild women in a collection that proves crime in early New Mexico wasn't only a boys' game.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Donna Blake Birchell
      </h2>
      
      <p class="authorDescription body article">Donna Birchell is the author of Carlsbad and Carlsbad Caverns, Eddy County" and "New Mexico Wine: An Enchanting History." She developed a passion for history through the inspiration of her history-buff parents, William and Dorothy Blake. While doing research for her other books, New Mexican Donna discovered a lack of combined written history about the slightly tarnished and definitely wicked ladies of New Mexico and thought the oversight should be corrected."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23b218eb